/**
 * SCSS IMPORT FILE
 * this file is just for scss imports which will create css classes
 */
import '@swisslife/shared-ui/src/base/bootstrap/css/bootstrap';
import '@swisslife/patterns-base/src/atoms/svg/css/svg';
import '@swisslife/patterns-base/src/molecules/rich-text/css/rich-text';
import '@swisslife/patterns-base/src/molecules/toast/css/toast';
import '../elements/tooltip-popup/css/tooltip-popup.scss';
import './tooltip.scss';
import './modifier/table.scss';
